import { customizeError } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getReviewedContracts } from '../../services/sanction'

export const GET_REVIEWED_CONTRACTS = 'GET_REVIEWED_CONTRACTS'
export const GET_REVIEWED_CONTRACTS_ERROR = 'GET_REVIEWED_CONTRACTS_ERROR'
export const GET_REVIEWED_CONTRACTS_SUCCESS = 'GET_REVIEWED_CONTRACTS_SUCCESS'
export const onGetReviewedContracts = makeActionCreator(GET_REVIEWED_CONTRACTS)
export const onGetReviewedContractsSuccess = makeActionCreator(GET_REVIEWED_CONTRACTS_SUCCESS, 'payload')
export const onGetReviewedContractsError = makeActionCreator(GET_REVIEWED_CONTRACTS_ERROR, 'payload')
export const onGetReviewedContractsThunk = payload => async dispatch => {
  dispatch(onGetReviewedContracts())
  try {
    const { data } = await getReviewedContracts({
      actionType: GET_REVIEWED_CONTRACTS,
      dni: payload?.dni
    })

    return dispatch(
      onGetReviewedContractsSuccess({
        reviewedContractsList: data?.payload?.map(contract => {
          return {
            dni: contract.codigo,
            publicationDate: contract.fechaPublicacionNota,
            contractId: contract.idContrato,
            contractName: contract.nombreContrato,
            contractScore: contract.notaContrato
          }
        })
      })
    )
  } catch (error) {
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetReviewedContractsError({
        error: customizeError({ originalError: error?.originalError, code: error?.code, reason }).toObject()
      })
    )
  }
}
